import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const DatenschutzPage = () => {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen" style={{ background: 'var(--bg-page)' }}>
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 border-b" style={{ background: 'var(--bg-page)', borderColor: 'var(--border-light)' }}>
        <div className="container">
          <div className="flex justify-between items-center py-4">
            <span
              className="text-2xl font-bold cursor-pointer"
              style={{ color: 'var(--brand-primary)' }}
              onClick={() => navigate('/')}
            >
              planniq
            </span>
            <button
              onClick={() => navigate('/')}
              className="btn-secondary flex items-center gap-2"
              style={{ padding: '0.5rem 1.25rem' }}
            >
              <ArrowLeft size={16} />
              Zurück
            </button>
          </div>
        </div>
      </nav>

      <div className="pt-32 pb-20">
        <div className="container">
          <div className="max-w-2xl">
            <h1 className="heading-2 mb-12" style={{ color: 'var(--text-primary)' }}>Datenschutzerklärung</h1>

            <section className="mb-10">
              <h2 className="heading-4 mb-4" style={{ color: 'var(--text-primary)' }}>1. Verantwortliche</h2>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                Verantwortliche im Sinne der DSGVO sind:<br />
                <br />
                Jakob Seidl &amp; Moritz Langbrucker<br />
                Amerlingstraße 15/14<br />
                1060 Wien, Österreich<br />
                <br />
                E-Mail: <a href="mailto:hello@planniq.at" style={{ color: 'var(--brand-primary)' }}>hello@planniq.at</a><br />
                Telefon: <a href="tel:+436606041926" style={{ color: 'var(--brand-primary)' }}>+43 660 6041926</a>
              </p>
            </section>

            <section className="mb-10">
              <h2 className="heading-4 mb-4" style={{ color: 'var(--text-primary)' }}>2. Kontaktaufnahme per E-Mail</h2>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                Wenn Sie uns per E-Mail kontaktieren, werden die übermittelten Daten ausschließlich zur Bearbeitung
                Ihrer Anfrage verwendet. Eine Weitergabe an Dritte findet nicht statt.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="heading-4 mb-4" style={{ color: 'var(--text-primary)' }}>3. Cookies und Tracking</h2>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                Diese Website verwendet keine Tracking-Cookies und keine Analyse- oder Werbedienste von Drittanbietern.
                Es werden keine personenbezogenen Daten für Marketingzwecke verarbeitet.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="heading-4 mb-4" style={{ color: 'var(--text-primary)' }}>4. Aktualität</h2>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                Diese Datenschutzerklärung hat den Stand April 2026 und kann bei Änderungen der Website oder der
                rechtlichen Rahmenbedingungen aktualisiert werden.
              </p>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default DatenschutzPage;
